import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchCommentsByUserId } from '../../store/slices/comment.slice'
import { fetchPosts } from '../../store/slices/post.slice'
import { Link } from 'react-router-dom'
import {
  postListNewImages,
  userProfileImages,
} from '../../services/images.service'
import { ArticleTag } from '../HomePage/ArticleTag'

const COMMENTS_PER_PAGE = 10

export function UserComments({ userId }) {
  const dispatch = useDispatch()
  const [currentPage, setCurrentPage] = useState(1)

  const comments = useSelector((state) => state.commentModule.comments || [])
  const allPosts = useSelector((state) => state.postModule.posts || [])
  const isLoading = useSelector((state) => state.commentModule.isLoading)

  useEffect(() => {
    if (userId) {
      dispatch(fetchCommentsByUserId(userId))
      dispatch(fetchPosts())
    }
  }, [dispatch, userId])

  const displayedComments = useMemo(() => {
    return comments.slice(0, currentPage * COMMENTS_PER_PAGE)
  }, [comments, currentPage])

  const relatedPostsMap = useMemo(() => {
    const relatedMap = {}
    displayedComments.forEach((comment) => {
      const post = allPosts.find((post) => post._id === comment.postId)
      if (post) relatedMap[comment.postId] = post
    })
    return relatedMap
  }, [displayedComments, allPosts])

  const handleLoadMore = () => {
    setCurrentPage((prev) => prev + 1)
  }

  if (isLoading) return <div className="text-center text-softText">טוען תגובות...</div>
  if (!comments.length) return <div className="text-center text-softText">לא נמצאו תגובות</div>

  return (
    <div className="container mx-auto px-4">
      {displayedComments
        .slice()
        .reverse()
        .map((comment) => {
          const relatedPost = relatedPostsMap[comment.postId]
          return (
            relatedPost && (
              <div
                key={comment._id}
                className="p-4 mb-8 rounded  flex flex-col  "
              >
                <div className="flex flex-col md:flex-row gap-4">
                  {/* תמונה */}
                  <div className="flex-shrink-0">
                    <img
                      src={relatedPost.imageUrl}
                      alt={relatedPost.title}
                      className="w-full md:w-56 h-44 object-cover "
                    />
                    <div className=" mt-[-10px]">
                      <ArticleTag tags={relatedPost.tags} />
                    </div>
                  </div>

                  {/* טקסט */}
                  <div className="flex flex-col justify-center w-full gap-4">
                    <div>
                      <h3 className="text-xl md:text-2xl text-white mb-1">
                        {relatedPost.title}
                      </h3>
                      <p className="text-xs md:text-sm text-gray-400">
                        תאריך יצירה:{' '}
                        {new Date(relatedPost.createdAt).toLocaleDateString()}
                      </p>
                    </div>
                    <div className="comment-content flex gap-3 items-start">
                      <img
                        src={userProfileImages.quoteIcon}
                        alt="Quote icon"
                        className="w-5 h-5 mt-1"
                      />
                      <p className="text-softText text-sm leading-snug">
                        {comment.content}
                      </p>
                    </div>

                    <div className="text-end">
                      <Link
                        to={`/post/${relatedPost._id}`}
                        className="text-sm text-primary hover:underline"
                      >
                        מעבר לפוסט
                      </Link>
                    </div>
                  </div>
                </div>

                <img
                  className="w-full mt-6"
                  src={postListNewImages.longLineDivider}
                  alt="Divider"
                />
              </div>
            )
          )
        })}

      {displayedComments.length < comments.length && (
        <div className="flex justify-center mt-6">
          <button
            className="w-[130px] h-[40px] bg-no-repeat bg-center bg-contain text-buttonSecondary1"
            style={{
              backgroundImage: `url(${postListNewImages.blockBtn})`,
            }}
            onClick={handleLoadMore}
          >
            טען עוד
          </button>
        </div>
      )}
    </div>
  )
}

